import { render, staticRenderFns } from "./wMultiSelect.vue?vue&type=template&id=5c4408b4&scoped=true&"
import script from "./wMultiSelect.vue?vue&type=script&lang=js&"
export * from "./wMultiSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c4408b4",
  null
  
)

export default component.exports